// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import getIdealColumns from '../getIdealColumns';

type PropTypes = {|
  columns: number,
  fitBestColumns: boolean,
  centerColumns: boolean,
  spacing: 'Small' | 'Medium',
  children: React.Node,
|};

const Columns = (props: PropTypes) => {
  let columns = Math.min(props.columns, 5);

  if (props.fitBestColumns) {
    columns = getIdealColumns(React.Children.count(props.children), columns);
  }

  const classname = cx(
    styles.container,
    styles[`is${columns}Column`],
    styles[`is${props.spacing}Spacing`],
    props.centerColumns && styles.isCenter,
  );

  // wrap in an extra div to make sure negative margin layout always works
  return (
    <div>
      <div className={classname}>{props.children}</div>
    </div>
  );
};

Columns.defaultProps = {
  fitBestColumns: false,
  centerColumns: false,
  spacing: 'Medium',
};

export default Columns;
